import { FC } from "react";

import ListItem from "@mui/material/ListItem";

import { IRefreshOption } from "./ControlRoomRefreshSection";

interface IControlRoomRefreshOptionProps {
  value: number;
  label: string;
  active?: boolean;
  onSelectedOptionChange: (option: IRefreshOption) => void;
}

const ControlRoomRefreshOption: FC<IControlRoomRefreshOptionProps> = ({
  value,
  label,
  active,
  onSelectedOptionChange,
}) => {
  return (
    <ListItem
      className={(active && "active") || ""}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        "&.active": {
          backgroundColor: theme => theme.palette.primary.shades?.["8p"],
          borderLeft: theme => `3px solid ${theme.palette.primary.main}`,
        },
      }}
      onClick={() => {
        onSelectedOptionChange({ value, label });
      }}
    >
      {label}
    </ListItem>
  );
};

export default ControlRoomRefreshOption;
